const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeEngagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillrule: "evenodd",
      fill: "rgba(237, 108, 2, 1)",
      fillOpacity: 1
    },
    d: "M 8.910156 2.5625 C 10.078125 1.316406 10.898438 0.242188 12.695312 0.03125 C 16.074219 -0.363281 19.179688 3.167969 17.472656 6.648438 C 16.988281 7.636719 16 8.816406 14.90625 9.972656 C 13.707031 11.242188 12.378906 12.484375 11.449219 13.425781 L 8.914062 16 L 6.816406 13.9375 C 4.292969 11.457031 0.179688 8.332031 0.046875 4.460938 C -0.046875 1.75 2.042969 0.0117188 4.453125 0.0429688 C 6.605469 0.0742188 7.511719 1.167969 8.910156 2.5625 Z M 8.910156 2.5625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeEngagement);
export default __webpack_public_path__ + "static/media/employeeEngagement.af0ed7ddccbef9ec8d03a11b2defceba.svg";
export { ForwardRef as ReactComponent };